import React from "react";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface PrintButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onPrint: () => void;
}

const PrintButton: React.FC<PrintButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onPrint,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="print-button"
      testId="print"
      variant="outlined"
      startIcon={<PrintOutlinedIcon />}
      onClick={onPrint}
    />
  );
};

export default PrintButton;
